import React, { useEffect } from 'react';
import bwipjs from 'bwip-js';
import classes from './Barcode.module.scss';
// import Countdown from 'react-countdown-now';

const Barcode = (props) => {
    const { content } = props;
    // const handleTick = (e) => {
    //     ctx.onUpdateTime(e.total);
    // };
    useEffect(() => {
        console.log(content);
        const setBarcode = (bcid, scale, height, haveText) => {
            try {
                bwipjs.toCanvas('mycanvas', {
                    bcid: bcid,
                    text: content?.redemption?.code?.value,
                    scale: scale,
                    height: height,
                    includetext: false,
                    textxalign: 'center',
                });
            } catch (e) {
                console.error('ERROR: ', e);
            }
        };
        // console.log(content.redemption.code.format);
        switch (content?.redemption?.code?.format) {            
            case 'QRCode':
                setBarcode('qrcode', 4, 18, true);
                break;
            case 'Code128':
                setBarcode('code128', 2, 10, true);
                break;
            case 'Code39':
                setBarcode('code39', 2, 10, true);
                break;
            case 'EAN-8':
                setBarcode('ean8', 2, 10, false);
                break;
            case 'EAN-13':
                setBarcode('ean13', 2, 10, false);
                break;
            case 'UPC-E':
                setBarcode('upce', 4, 10, false);
                break;
            case 'UPC-A':
                setBarcode('upca', 2, 15, false);
                break;
            case 'ITF14':
                setBarcode('itf14', 2, 10, true);
                break;
            case 'PDF417':
                setBarcode('pdf417', 2, 10, true);
                break;
            case 'Aztec':
                setBarcode('azteccode', 6, 12, true);
                break;
            case 'DataMatrix':
                setBarcode('datamatrix', 6, 12, true);
                break;
            default:
                alert('error displaying barcode');
        }
    }, [content]);

    return (
        <div className={classes.Barcode}>
            <div style={{ display: props.showBarcode ? 'block' : 'none' }}>                
                <canvas id='mycanvas' style={{width: '100%'}}></canvas>
            </div>
            {/* <div
                className={classes.CountDown}
                style={{
                    display:
                        props.showCountdown && ctx.expTime > 0
                            ? 'block'
                            : 'none',
                }}>
                <span className={classes.CountDownText}>
                    This code is available for
                    <Countdown
                        style={{ color: '#FF0000', marginLeft: '3px' }}
                        onTick={handleTick}
                        date={Date.now() + ctx.expTime}
                        onComplete={props.handleExpire}
                    />
                </span>
            </div> */}
            <p style={{fontSize: props?.content?.redemption?.code?.value && props?.content?.redemption?.code?.value.length > 24  ? "12px" : "24px"}}>{props?.content?.redemption?.code?.value}</p>
        </div>
    );
};

export default Barcode;
